import useClawStatus, { ClawStatus } from '@src/stores/useClawStatus';
import ClawGuide from './Guide';
import ClawPending from './Pending';
import ClawChatContent from './ChatContent';
import { useClawBotStatus } from '@src/hooks/useClawBotStatus';
import { Toast } from '@kim/ui';

export const ClawHome = () => {
  const { status: clawStatus, init } = useClawStatus();
  useClawBotStatus({ polling: true });

  // staging 直接到 chat 页面
  if (location.hostname.includes('staging')) {
    return <ClawChatContent />;
  }

  if ((init && clawStatus !== ClawStatus.OPENED) || clawStatus === ClawStatus.OPENING) {
    return <ClawPending />;
  }

  switch (clawStatus) {
    case ClawStatus.NOT_OPEN:
      return <ClawGuide />;
    case ClawStatus.OPENED:
      return <ClawChatContent />;
  }

  if (clawStatus === ClawStatus.ERROR) {
    Toast({
      message: '开通失败，请重试',
      type: 'error',
      duration: 3,
    });
    return <ClawGuide />;
  }
};